import { DecimalPipe, PercentPipe } from "@angular/common";
import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input,
	OnChanges,
	SimpleChanges,
	ViewEncapsulation,
} from "@angular/core";
import { CurrencyService } from "@obg/ngx.global";
import { coerceBoolean } from "@obg/ngx.global.evo";

import { ProgressBarMode, ProgressBarOptions, ProgressBarType } from "./progress-bar.model";

const DEFAULT_OPTIONS: ProgressBarOptions = {
	type: ProgressBarType.Currency,
};

@Component({
	selector: "obg-progress-bar",
	templateUrl: "./progress-bar.component.html",
	styleUrls: ["./progress-bar.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent implements OnChanges {
	@HostBinding("class.obg-progress-bar") hostCssClass = true;

	@Input() value = 0;
	@Input() maxValue = 100;

	@Input()
	@coerceBoolean()
	hideValues = false;

	@Input()
	@coerceBoolean()
	showCurrentLimit = false;

	@Input()
	@coerceBoolean()
	roundedCorners = false;

	@Input()
	@HostBinding("attr.mode")
	mode = ProgressBarMode.Default;

	@Input()
	get options(): ProgressBarOptions {
		return this._options;
	}
	set options(value: ProgressBarOptions) {
		this._options = { ...DEFAULT_OPTIONS, ...value };
	}

	percentageValue: number | undefined;

	private _options = DEFAULT_OPTIONS;

	constructor(
		private currencyService: CurrencyService,
		private percentPipe: PercentPipe,
		private decimalPipe: DecimalPipe
	) {}

	ngOnChanges(_changes: SimpleChanges) {
		if (this.maxValue >= this.value) {
			this.percentageValue = (this.value / this.maxValue) * 100;
		} else {
			this.percentageValue = 100;
		}
	}

	formatValue(value: number): string | null {
		switch (this.options.type) {
			case ProgressBarType.Currency:
				return this.currencyService.format(value, undefined, undefined, this.options.valueFormat);
			case ProgressBarType.Percentage:
				return this.percentPipe.transform(value / 100, this.options.valueFormat);
			default:
				return this.decimalPipe.transform(value, this.options.valueFormat);
		}
	}
}
